import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { useCampaignModuleContext } from 'modules/campaigns/context';
import { VenueViewer } from 'modules/venue-selector';

import { SelectedVenueList } from './SelectedVenueList';
import { VenueRowItem } from './VenueRowItem';
import CampaignFormItem from '../CampaignFormItem';

type VenuesDetailsProps = {
  venueIds: string[];
};

const VenuesDetailsRoot = styled.div`
  margin-block-start: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const VenuesDetails = ({ venueIds }: VenuesDetailsProps) => {
  const { venues } = useCampaignModuleContext();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const selectedVenueSelectItems = venues.filter(venue => venueIds.includes(venue.id));
  return (
    <CampaignFormItem
      data-testid={'venues-form-item'}
      title={<FormattedMessage id="campaigns.form.venues.title" />}
      value={
        <VenuesDetailsRoot>
          <VenueViewer
            rowRenderer={VenueRowItem}
            venueSelectItems={selectedVenueSelectItems}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
          />
          <SelectedVenueList venueSelectItems={selectedVenueSelectItems} onViewAll={() => setIsModalOpen(true)} />
        </VenuesDetailsRoot>
      }
    />
  );
};
